export default __webpack_public_path__ + "static/media/34-TimidKereru.7cd25923.jpeg";